import React, { FC, useState } from 'react';
import { ModalManagementButtons } from '../ModalManagementButtons';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { COMMENT_FORM_FIELD, commentDetailsSchema, commentInitialValues } from '../../constants/comment/comment-form';
import { FormInput } from '../merchants/FormInput';
import { InputType } from '../form/form-input-constants';
import { updateApplicationRiskStatus } from '../../store/merchnts/actions/application-details';
import { useParams } from 'react-router-dom';
import { useMerchants } from '../../store/merchnts/merchants-context';

interface Props {
  name: string;
  status: string;
  riskCategory: string;
  onClose: () => void;
}

export const ApplicationReviewRiskModal: FC<Props> = (props) => {
  const { name, status, riskCategory, onClose } = props;
  const { t } = useTranslation();
  const { applicationId } = useParams<{ applicationId: string }>();
  const { merchantState: { isRiskRequestLoading }, dispatch } = useMerchants();

  const [sendToSailsChecked, setSendToSailsChecked] = useState<boolean>(false);
  // const [sendToApplicant, setSendToApplicant] = useState<boolean>(false);

  const formik = useFormik({
    initialValues: commentInitialValues,
    validationSchema: commentDetailsSchema,
    onSubmit: async (): Promise<void> => {
      if (!formik.isValid) return;
      const params = {
        type: status,
        comment: formik.values[COMMENT_FORM_FIELD.COMMENT],
        // sendSailsEmail: sendToSailsChecked,
        riskCategory
      };
      const handleSuccess = (): void => {
        onClose();
      };
      await updateApplicationRiskStatus({
        dispatch,
        applicationId,
        params,
        handleSuccess,
        handleError: onClose
      });
    },
  });

  return (
    <form className="px-8 pb-8" onSubmit={formik.handleSubmit}>
      <div>
        You are about to update the application to
        <span className="fw-bolder ms-1">{t(name)}.</span>
      </div>
      {/*{*/}
      {/*  status === RISK_STATUSES.REMEDIATED && (*/}
      {/*    <div>*/}
      {/*      This will move the application back to*/}
      {/*      <span className="fw-bolder mx-1">Draft</span>*/}
      {/*      mode.*/}
      {/*    </div>*/}
      {/*  )*/}
      {/*}*/}
      <FormInput
        formik={formik}
        key={COMMENT_FORM_FIELD.COMMENT}
        fieldName={COMMENT_FORM_FIELD.COMMENT}
        label="To proceed, please write your comments below:"
        placeholder={t('APPLICATION_DETAILS.LABEL.TEXTAREA_APPROVED_PLACEHOLDER')}
        inputType={InputType.Description}
        isEditMode={true}
        // additionalClasses={additionalClass}
      />

      {/*<div className="form-check d-flex align-items-center mt-2">*/}
      {/*  <input*/}
      {/*    type="checkbox"*/}
      {/*    className="form-check-input me-2"*/}
      {/*    checked={sendToSailsChecked}*/}
      {/*    onChange={(e): void => setSendToSailsChecked(e.target.checked)}*/}
      {/*  />*/}
      {/*  <label className="form-check-label fs-8">{t('APPLICATION_DETAILS.LABEL.SALES_CHECKBOX')}</label>*/}
      {/*</div>*/}

      {/*{*/}
      {/*  status === RISK_STATUSES.DECLINED && (*/}
      {/*    <div className="form-check d-flex align-items-center mt-2">*/}
      {/*      <input*/}
      {/*        type="checkbox"*/}
      {/*        className="form-check-input me-2"*/}
      {/*        checked={sendToApplicant}*/}
      {/*        onChange={(e): void => setSendToApplicant(e.target.checked)}*/}
      {/*      />*/}
      {/*      <label className="form-check-label fs-8">{t('APPLICATION_DETAILS.LABEL.APPLICANT_CHECKBOX')}</label>*/}
      {/*    </div>*/}
      {/*  )*/}
      {/*}*/}
      <ModalManagementButtons
        onCancel={onClose}
        containerAdditionalClasses="mt-10"
        isConfirmBtnLoading={isRiskRequestLoading}
        confirmBtnName="Update status"
        confirmBtnAdditionalClasses="w-160px"
      />
    </form>
  );
};
